/**
 * Configuración centralizada de todas las tareas cron
 * Para agregar una nueva tarea, simplemente añádela a este array
 */
import {
  ArrowPathIcon,
  BuildingOffice2Icon,
  ClipboardDocumentCheckIcon,
  CubeIcon,
  LinkIcon,
  TruckIcon,
} from '@heroicons/react/24/outline'
import type { ComponentType } from 'react'

export interface CronTaskConfig {
  id: string
  name: string
  description: string
  icon: ComponentType<{ className?: string }>
  endpoints: {
    status: string
    execute: string
    count?: string
  }
  permission?: string
  pollingInterval?: number // Intervalo en ms (default: 30000 = 30s)
  showCount?: boolean // Mostrar contador de pendientes
  manualExecute?: boolean // Habilitar botón de ejecución manual
  /** Método HTTP para ejecutar la tarea (default: POST). Bold usa GET. */
  executeMethod?: 'GET' | 'POST'
}

/**
 * Configuración de todas las tareas cron disponibles
 */
export const CRON_TASKS_CONFIG: CronTaskConfig[] = [
  {
    id: 'mercadolibre-sync-shipments',
    name: 'Sincronizar Estados de Pedidos ML',
    description: 'Sincroniza estados de MercadoLibre.',
    icon: ArrowPathIcon,
    endpoints: {
      status: '/mercadolibre/orders/sync-shipments/status',
      execute:'/mercadolibre/orders/sync-shipments',
      count:  '/mercadolibre/orders/sync-shipments/count',
    },
    permission: 'view_cron_mercadolibre',
    pollingInterval: 30000, // 30 segundos
    showCount: true,
  },
  {
    id: 'homecenter-sync-pending',
    name: 'Sincronizar estados de HomeCenter',
    description: 'Sincroniza pedidos pendientes de HomeCenter',
    icon: BuildingOffice2Icon,
    endpoints: {
      status: '/homecenter/scheduled-status',
      execute: '/homecenter/sync-pending-now',
      count: '/homecenter/sync-pending-orders/count',
    },
    permission: 'view_cron_homecenter',
    pollingInterval: 30000, // 30 segundos
    showCount: true, // Mostrar contador de pedidos pendientes
    manualExecute: true, // Habilitar botón de ejecución manual
  },
  {
    id: 'webhook-retry-failed',
    name: 'Reintentar Envía/Envia.com',
    description: 'busca directamenteen estados que fallaron.',
    icon: ArrowPathIcon,
    endpoints: {
      status: '/webhook/retry-failed/status',
      execute: '/webhook/retry-failed',
      // El count podría obtenerse de /webhook/envia/stats pero requiere adaptador
    },
    permission: 'view_cron_webhook_envia',
    pollingInterval: 30000, // 30 segundos
    showCount: true, // El count se extrae del status response (stats.total_pendientes)
    manualExecute: true, // Habilitar botón de ejecución manual
  },
  {
    id: 'bold-verify-links',
    name: 'Verificación de links Bold',
    description:
      'Verifica links LNK_% en Bold y verifica si ya tiene un payment ID.',
    icon: LinkIcon,
    endpoints: {
      status: '/cron/status',
      execute: '/cron/bold-verify-links',
    },
    permission: 'view_cron_bold_links',
    pollingInterval: 30000,
    showCount: false,
    manualExecute: false,
    executeMethod: 'GET',
  },
  {
    id: 'bold-voucher-verify',
    name: 'Verificador de pagos Bold',
    description:
      'Consulta a Bold pedidos con método Bold y reafirma si realmente el pago fue aprobado.',
    icon: ClipboardDocumentCheckIcon,
    endpoints: {
      status: '/cron/status',
      execute: '/cron/bold-voucher-verify',
    },
    permission: 'view_cron_bold_voucher',
    pollingInterval: 30000,
    showCount: false,
    manualExecute: false,
    executeMethod: 'GET',
  },
  {
    id: 'flexy-stock-sync',
    name: 'Sincronizar Stock Flexy',
    description:
      'Sincroniza stock desde Flexy WMS hacia SGL/MDM (cada 30 min).',
    icon: CubeIcon,
    endpoints: {
      status: '/flexy/stock/status',
      execute: '/flexy/stock/sync',
    },
    permission: 'view_cron_flexy_stock',
    pollingInterval: 30000,
    showCount: true,
    manualExecute: true,
    executeMethod: 'POST',
  },
  {
    id: 'envia-hub-sync-guias',
    name: 'Envía Colvanes (Hub)',
    description:
      'Sincroniza guías Envía Hub (Colvanes) y actualiza pedidos en SGL. Transportadora Envía.',
    icon: TruckIcon,
    endpoints: {
      status: '/cron/status',
      execute: '/cron/envia-hub-sync-guias',
    },
    permission: 'view_cron_envia_hub',
    pollingInterval: 30000,
    showCount: false,
    manualExecute: true,
    executeMethod: 'GET',
  },
  // Aquí se pueden agregar más tareas cron fácilmente:
  // {
  //   id: 'otra-tarea',
  //   name: 'Otra Tarea',
  //   description: 'Descripción de la tarea',
  //   icon: ClockIcon,
  //   endpoints: {
  //     status: '/api/otra-tarea/status',
  //     execute: '/api/otra-tarea/execute',
  //   },
  //   permission: 'view_settings',
  //   pollingInterval: 30000,
  //   showCount: false,
  // },
]

/**
 * Obtener configuración de una tarea por ID
 */
export const getCronTaskConfig = (id: string): CronTaskConfig | undefined => {
  return CRON_TASKS_CONFIG.find((task) => task.id === id)
}

/**
 * Obtener todas las tareas configuradas
 */
export const getAllCronTasksConfig = (): CronTaskConfig[] => {
  return CRON_TASKS_CONFIG
}

